// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {find, get} from 'lodash';

// Components
import Permissions from '../core/permissions';
import SearchTableWithSort from '../app/search-tablewithsort';
import ServicesExportPanelAction from '../app/services-export-panel-action';

// Containers
import withSearch from '../../containers/with-search';

// Contexts
import {SearchContext} from '../../contexts/search-context';

// Redux Actions
import {
    mapExternalNetworks,
    networkMappingReset,
    setExternalNetworkChecked,
    setNetwork,
} from '../../actions/network-actions';

const servicesDataKey = 'unmappedExternalNetworks';

class UnmappedExternalNetworks extends Component {
    componentWillMount() {
        const {networkMappingReset} = this.props;

        networkMappingReset();
    }

    componentWillReceiveProps(nextProps) {
        const {externalNetworks, mappingComplete, fetching} = this.props;
        const {refreshServicesData} = this.context;

        if ((mappingComplete || (externalNetworks.length && !nextProps.externalNetworks.length)) && !fetching) {
            refreshServicesData();
        }
    }

    getColumnConfig() {
        const {externalNetworks} = this.props;
        return [
            {
                dataKey: 'externalNetworkId',
                title: 'Id',
                width: '10%',
            },
            {
                dataKey: 'name',
                title: 'Name',
                width: '40%',
            },
            {
                dataKey: 'provider.name',
                title: 'Provider',
                width: '40%',
            },
            {
                checked: (searchData, _column) => {
                    const externalNetworkName = get(searchData, 'name');
                    const partnerId = get(searchData, 'provider.partnerId');

                    return find(externalNetworks, {externalNetworkName, partnerId});
                },
                dataKey: '',
                onChange: this.checkboxOnChange,
                title: 'Map',
                tooltip: 'Map this external network to selected network',
                type: 'checkbox',
                recordKey: 'externalNetworkId',
                width: '10%',
            },
        ];
    }

    getTablewithsortProps() {
        return {
            ...this.props,
            activeRowKey: 'externalNetworkId',
            className: 'unmapped-external-networks--search',
            columnConfig: this.getColumnConfig(),
            servicesDataKey,
            updateOnUrlChange: false,
        };
    }

    checkboxOnChange = (data) => {
        const {setExternalNetworkChecked} = this.props;

        return function(event) {
            const isChecked = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

            setExternalNetworkChecked(data.name, data.provider.partnerId, isChecked);
        };
    };

    render() {
        const {searchData} = this.props;

        return (
            <Permissions
                accessRequirement="update"
                elementService="network"
                notAuthorizedMessage={true}
                requiresServiceAccess={true}
            >
                <div className="unmapped-external-networks">
                    <SearchTableWithSort {...this.getTablewithsortProps()} />
                    <ServicesExportPanelAction searchData={searchData} />
                </div>
            </Permissions>
        );
    }
}

UnmappedExternalNetworks.propTypes = {
    externalNetworks: PropTypes.array,
    fetching: PropTypes.bool,
    mappingComplete: PropTypes.bool,
    networkMappingReset: PropTypes.func.isRequired,
    searchData: PropTypes.array,
    setExternalNetworkChecked: PropTypes.func.isRequired,
};

UnmappedExternalNetworks.contextType = SearchContext;

const mapStateToProps = (state) => ({
    externalNetworks: get(state, 'networks.externalNetworks'),
    mappingComplete: get(state, 'networks.mappingComplete'),
});

const mapDispatchToProps = {
    mapExternalNetworks,
    networkMappingReset,
    setExternalNetworkChecked,
    setNetwork,
};

export default withSearch(connect(mapStateToProps, mapDispatchToProps)(UnmappedExternalNetworks), servicesDataKey);
